/**
 * Operator Fleet view — KB's view (principal role only).
 * All tenants, agent health, coverage %, campaign performance.
 * Raw frontier vocabulary — MembraneLanguage bypassed.
 */

import { useState, useEffect } from "react";
import { getClients } from "../lib/api-clients";

export function OperatorFleetView() {
  const [fleet, setFleet] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const clients = getClients();
    if (!clients) { setLoading(false); return; }
    clients.control.getFleet()
      .then((res: any) => setFleet(res))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading">Loading fleet…</div>;
  if (error) return <div className="error-state">{error}</div>;

  const tenants = fleet?.tenants || [];

  return (
    <div className="view">
      <div className="view-header">
        <span className="eyebrow">Operator</span>
        <h1>Fleet Overview</h1>
      </div>

      {/* Summary */}
      <div className="card-grid">
        <div className="card">
          <div className="card-title">Total Tenants</div>
          <div className="card-meta">{tenants.length}</div>
        </div>
        <div className="card">
          <div className="card-title">Active Agents</div>
          <div className="card-meta">{tenants.filter((t: any) => t.agent_status === "active").length}</div>
        </div>
        <div className="card">
          <div className="card-title">Avg Coverage</div>
          <div className="card-meta">
            {tenants.length > 0
              ? Math.round(tenants.reduce((sum: number, t: any) => sum + (t.coverage_pct ?? 0), 0) / tenants.length)
              : 0}%
          </div>
        </div>
      </div>

      {/* Tenant table */}
      <table className="data-table">
        <thead>
          <tr>
            <th>Tenant</th><th>Agent Status</th><th>Coverage</th><th>Campaigns</th><th>Replies</th><th>F-Stage</th>
          </tr>
        </thead>
        <tbody>
          {tenants.map((t: any, i: number) => (
            <tr key={i}>
              <td>{t.name || t.id}</td>
              <td><span className="badge" data-status={t.agent_status}>{t.agent_status || "unknown"}</span></td>
              <td>{t.coverage_pct ?? 0}%</td>
              <td>{t.campaign_count ?? 0}</td>
              <td>{t.reply_count ?? 0}</td>
              <td><span className="badge">{t.current_stage || "—"}</span></td>
            </tr>
          ))}
        </tbody>
      </table>
      {tenants.length === 0 && <div className="empty-state">No tenants provisioned.</div>}
    </div>
  );
}
